import NoOrder from "./NoOrder";
import React from "react";
import { Due, Item } from "../common";
import _ from "lodash";

interface OwedSectionProps {
  dues: Due[];
  items: Item[];
}

/**
 * If items are ordered, this component shows who owes what.
 */
const OwedSection: React.FC<OwedSectionProps> = ({ dues, items }) => {
  const allUniqueDiners = _.uniq(_.flatten(items.map((item) => item.people)));

  const copyItemData = () => {
    const lines: string[] = dues.map(
      (due: Due) => `${due.name} owes ${due.cost.toFixed(2)}`
    );

    navigator.clipboard
      .writeText(lines.join("\n"))
      .then(() => {
        alert("Receipt data copied!");
      })
      .catch(() => {
        alert("Something went wrong, please copy manually :(");
      });
  };

  return (
    <div className="main-section">
      <h3 className="text-center mb-4">Who Owes What</h3>
      {_.isEmpty(dues) && <NoOrder />}
      {/* Just show a random person here */}
      {dues.length > 0 && (
        <p className="venmo text-center">
          {" "}
          If you can't decide, have <b>{_.sample(allUniqueDiners)}</b> pay and
          Venmo them.{" "}
        </p>
      )}
      <ul className="text-center">
        {dues.map((due: Due, index: number) => (
          <li key={index}>
            <b>{due.name}</b> owes ${due.cost.toFixed(2)}
          </li>
        ))}
      </ul>
      {dues.length > 0 && (
        <div className="text-center mt-3 mb-3">
          <button className="btn btn-outline-secondary" onClick={copyItemData}>
            Copy
          </button>
        </div>
      )}
    </div>
  );
};

export default OwedSection;
